<template>
    <div class="arcman">
        <div class="arcman__app-bar-wrapper">
            <app-bar v-if="isAuthenticated"></app-bar>
        </div>
        <div class="arcman__view-wrapper">
            <router-view @showSpinner="showSpinner"></router-view>
        </div>
        <!--FIXME To be replaced with portal pattern later-->
        <div class="app__spinner-wrapper" v-if="isSpinning">
            <spinner>
                <template v-slot:spinnerContent><div class="app__spinner"></div></template>
            </spinner>
        </div>
        <sah-modal></sah-modal>
    </div>
</template>

<script>
import {store, Spinner} from "atom";
import AppBar from "@/components/AppBar.vue";
import SahModal from "@/components/SahModal.vue";
const {createNamespacedHelpers} = store;
const {mapGetters} = createNamespacedHelpers("arcman");
export default {
    name: "arcman",
    components: {
        AppBar,
        SahModal,
        Spinner,
    },
    computed: {
        ...mapGetters(["isAuthenticated", "showAppSpinner"]),
        isSpinning() {
            return this.showChildSpinner || this.showAppSpinner;
        },
    },
    data() {
        return {
            showChildSpinner: false,
        };
    },
    methods: {
        showSpinner(event) {
            this.showChildSpinner = event;
        },
    },
};

/**
 * Application's root component
 */
</script>

<style lang="scss" src="@/assets/styles/app.scss"></style>
<style scoped lang="scss">
.arcman::v-deep {
    .sah-button {
        @apply text-white border-0  py-2 px-4 rounded;
        max-width: $max-button-width;
        background-color: $background-button-color;
        &:focus {
            outline: none;
        }
        &:hover {
            @apply cursor-pointer;
            background-color: $background-button-hover-color;
        }
        &:disabled {
            @apply opacity-50 cursor-not-allowed;
        }
    }

    .app-page-header__button {
        @apply absolute right-0 mr-4;
    }

    .app__button_alt {
        @apply mr-2;
        background-color: $background-button-alt-color;
    }
}
</style>
